import { CheckboxField, SelectField } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import classNames from 'classnames';
import { forwardRef } from 'react';
const containerCss = "c1jqc7fi";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
export const ReminderField = () => {
  const options = [{
    name: I18n.t('publisher.send_from_calendly.reminder.options.day'),
    value: 1
  }, {
    name: I18n.t('publisher.send_from_calendly.reminder.options.three_days'),
    value: 3
  }, {
    name: I18n.t('publisher.send_from_calendly.reminder.options.week'),
    value: 7
  }];
  return <Container>
      <CheckboxField name="isReminderActive" label={I18n.t('publisher.send_from_calendly.reminder.label')} />
      <SelectField name="remindInDays" variant="minimal" options={options} aria-label={I18n.t('publisher.send_from_calendly.reminder.options_label')} />
    </Container>;
};

require("./reminder_field.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./reminder_field.js");